import React from 'react';

import PropTypes from 'prop-types';

import { StyledPageContainer } from './styles';

const PageContainer = ({ children, maxWidth = 1400 }) => {
  return <StyledPageContainer $maxWidth={maxWidth}>{children}</StyledPageContainer>;
};

PageContainer.propTypes = {
  children: PropTypes.node.isRequired,
  maxWidth: PropTypes.number,
};

export default PageContainer;
